type AudienceSelectionProp = {
  audiencesData: any;
  filteredAudiences: any;
  handleAudienceSelect: (aud: string) => void;
  selectedAudience: string | null;
};

const AudienceSelection = ({
  audiencesData,
  filteredAudiences,
  handleAudienceSelect,
  selectedAudience,
}: AudienceSelectionProp) => {
  return (
    <section className="flex flex-wrap items-center gap-2 mb-4 border-b border-black pb-[25px] border-opacity-25">
      <p className="text-sm font-medium text-gray-700 mr-2">Select Audience:</p>

      {audiencesData.meta?.isProcessing && filteredAudiences.length === 0 ? (
        Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="h-8 w-20 rounded-full bg-gray-200 animate-pulse"
          />
        ))
      ) : filteredAudiences.length === 0 ? (
        <span className="text-xs text-gray-500 py-1">No audiences found</span>
      ) : (
        filteredAudiences.map((aud: string) => (
          <button
            key={aud}
            onClick={() => handleAudienceSelect(aud)}
            className={`rounded-full px-3 py-1 flex items-center cursor-pointer transition-all text-xs ${
              selectedAudience === aud
                ? "text-black border-2 border-black bg-gray-50"
                : "text-gray-700 border border-gray-300 hover:border-gray-400 hover:bg-gray-50"
            }`}
          >
            <span className="font-medium">{aud}</span>
          </button>
        ))
      )}
    </section>
  );
};

export default AudienceSelection;
